import { useState } from 'react';
import {
  Flex,
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { ChevronDown } from '@kula-ai/icons/dual-tone/ChevronDown';

interface KButtonProps {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'danger'; // Add other variants as needed
  size?: 'sm' | 'md' | 'lg';
  buttonType?: 'rounded' | 'icon-only' | 'no-border';
  children: React.ReactNode;
  icon?: React.ElementType;
  iconProps?: any;
  [key: string]: any; // For any additional props
}

export const KButton: React.FC<KButtonProps> = ({
  variant = 'primary',
  size = 'md',
  buttonType,
  children,
  icon,
  iconProps,
  ...props
}) => {
  const sizes = { lg: '2.75rem', md: '2rem' };

  const styles = {
    rounded: { borderRadius: '50px' },
    'icon-only': { padding: '8px' },
    'no-border': {
      border: 'none',
      _hover: { border: 'none', backgroundColor: 'transparent' },
    },
  };

  return (
    <Button
      display="inline-flex"
      gap="6px"
      variant={variant}
      height={sizes[size]}
      {...props}
      {...styles[buttonType]}
    >
      {icon && <Icon as={icon} w="16px" h="16px" {...iconProps} />}
      {children}
    </Button>
  );
};

export const KDropDownButton = ({
  variant = 'primary',
  size = 'md',
  buttonType = 'dropdown',
  children,
  icon,
  options = [],
  onValueSelected = (_value) => {},
  ...props
}) => {
  const sizes = { lg: '2.75rem', md: '2rem' };
  const [value, setValue] = useState(options?.[0]);

  const handleOnChange = (value) => {
    setValue(value);
    onValueSelected(value);
  };

  return (
    <Menu direction="ltr" offset={[0, 4]}>
      <Flex>
        <Button
          gap="6px"
          borderRightRadius="0px"
          borderRight="none"
          variant={variant}
          height={sizes[size]}
          {...props}
          onClick={() => handleOnChange(value)}
        >
          {value?.label}
        </Button>
        <Button
          as={MenuButton}
          gap="6px"
          px="6px !important"
          borderLeftRadius="0px"
          borderLeft={variant === 'primary' && '1px solid #797DFF'}
          variant={variant}
          height={sizes[size]}
        >
          <Icon as={ChevronDown} w="16px" h="16px" mt="5px" />
        </Button>
      </Flex>

      <MenuList>
        {options?.map((option) => (
          <MenuItem key={option?.id} onClick={() => handleOnChange(option)}>
            {option?.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
